import { Component, input, OnDestroy, OnInit, Provider } from '@angular/core';
import { CoreContexts, CoreContextService } from '../core-context.service';
import { CoreContext } from '../_core/contexts/core-context';
import { ClientCoreContext } from '../_core/contexts/client-core-context';
import { IonRouterOutlet, ModalController, PopoverController } from '@ionic/angular/standalone';
import { WhatsappNotificationService } from '../../services/whatsapp-notification.service';
import { ProductsService } from '../magazzino/products.service';
import { CollaboratorsService } from '../collaborators/collaborators.service';
import { ServicesService } from '../services/services.service';
import { PromotionService } from '../promotions/application/promotion.service';
import { CustomersService } from '../customers/customers.service';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeModule } from 'angularx-qrcode';
import { ColorPickerService } from 'ngx-color-picker';

const providers: Provider[] = [
    // CoreContextService, // Already root-provided
    // PermissionsService,
	ModalController,
	PopoverController,
	// ProductsService, // Now root-provided
	// ServicesService, // Now root-provided
	// CollaboratorsService, // Now root-provided
	// CustomersService, // Now root-provided
	// PromotionService, // Now root-provided
	WhatsappNotificationService,
	ColorPickerService
];

@Component({
	selector: 'app-core-root',
	standalone: true,
	imports: [
		// IonicModule,
		TranslateModule,
		IonRouterOutlet,
	],
	providers: providers,
	templateUrl: './app-core-root.component.html',
	styleUrl: './app-core-root.component.css',
})
export class AppCoreRootComponent implements OnInit, OnDestroy {
	public context = input.required<CoreContexts>();
	public noRouting = input<boolean>(false);

	constructor(public readonly _contextService: CoreContextService) {}

	ngOnInit() {
		const context = this.context();
		this._contextService.setContext(context);
	}

	ngOnDestroy(): void {
		console.log('app-core-root OnDestroy', this.context());
	}
}
